import styles from './SolutionFlatCard.scss';

import React, { FC, HTMLAttributes } from 'react';

import { Subject } from 'src/api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'src/components/ContentImage/ContentImage';
import { ContentLinkV2 } from 'src/components/ContentLinkV2/ContentLinkV2';
import { Grid } from 'src/components/Grid/Grid';
import { TextV2 } from 'src/components/TextV2/TextV2';
import { FlatEntry } from 'src/services/cms/flattenContentful';

interface SolutionFlatCardProps extends HTMLAttributes<HTMLElement> {
  item?: FlatEntry<Subject>;
}
export const SolutionFlatCard: FC<SolutionFlatCardProps> = ({
  item,
}) => {
  if (!item) return null;
  const { title: buttonTitle, blurb, mobileImage, link } = item;

  return (
    <Grid key={buttonTitle} item xs={12} className={styles.solutionPickerModuleSliderContainer}>
      <div className={styles.solutionPickerModuleButton}>
      <ContentLinkV2 entry={link} hideTitle>
        <ContentImage entry={mobileImage} className={styles.solutionPickerModuleButtonImage} isLazyLoad={false} />
        <TextV2
          value={buttonTitle}
          entry={{ ...item, field: 'title' }}
          tagName="h5"
          variant="h5-medium"
          className={styles.solutionPickerModuleButtonText}
        />
        <TextV2
          value={blurb}
          entry={{ ...item, field: 'blurb' }}
          tagName="p"
          variant="body"
          className={styles.solutionPickerModuleButtonBlurb}
        />
      </ContentLinkV2>
      </div>
    </Grid>
  );
};
SolutionFlatCard.displayName = 'SolutionFlatCard';
